import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { useDevices } from "../../../../Hooks/useDevices";

const filters = ["All", "Assigned", "Unassigned", "Archived"];

const StatusTabs = ({ activeStatus }) => {
  const navigate = useNavigate();
  const { devices } = useDevices();

  const modifiedDevices = useMemo(() => {
    if (!devices) return [];
    return [{ id: "all", device_name: "All" }, ...devices];
  }, [devices]);

  const handleFilterClick = (device) => {
    const deviceName = device;
    // Only navigate - the state will update via useEffect in parent
    if (deviceName !== "All") {
      const path = `/devices/${deviceName.toLowerCase().replace(/ /g, "-")}`;
      navigate(path);
    } else {
      navigate("/devices/all");
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {filters &&
        filters.map((device) => (
          <Box
            key={device.id}
            sx={{
              padding: "9px 18px",
              borderRadius: "4px",
              backgroundColor: device === activeStatus ? "#ECE9F1" : "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleFilterClick(device)}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 500,
                color: device === activeStatus ? "#252525" : "#5D6679",
              }}
            >
              {device}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

export default StatusTabs;
